<template>
  <div class="row">
    <div class="col-md-10">
      <template v-for="(level1, level1id) in jsonstartquestion.level1">
        <div class="alert alert-warning" :key="level1id">
          {{ level1.name }}
        </div>
        <template v-for="(level2, level2id) in level1.level2">
          <div class="alert alert-info" :key="level2id">
            {{ level2.name }}
          </div>
          <div
            class="well"
            v-for="(quest, questid) in level2.question"
            :key="questid"
          >
            <strong>{{ quest.val }}</strong>
            
            <div
              class="form-group clearfix"
              v-for="(answer, answerid) in quest.answers"
              :key="answerid"
            >
              <input
                :name="'pole_' + level1id + level2id + questid"
                :id="'pole_' + level1id + level2id + questid + answerid"
                type="radio"
                :value="answer.id"
                v-model="quest.now"
              />
              <label
                class="form-control btn btn-info"
                :for="'pole_' + level1id + level2id + questid + answerid"
                >{{ answer.val }}</label
              >
            </div>
          </div>
        </template>
      </template>
      <button class='form-control btn btn-info' @click='startnewsave();'>Сохранить</button>
      <template v-for="(level1, level1id) in jsonquestion.level1">
        <div class="alert alert-warning" :key="'lvl1-'+level1id">
          {{ level1.name }}
        </div>
        <template v-for="(level2, level2id) in level1.level2">
          <div class="alert alert-info" :key="'lvl2-'+level2id">
            {{ level2.name }}
          </div>
          <div
            class="well"
            v-for="(quest, questid) in level2.question"
            :key="questid"
          >
            <strong>{{ quest.val }}</strong>

            <div v-if="level1id == 3 && site != '' && site != undefined">
              Сайт образовательной организации: 
              <a :href='site' target="_blank">{{site}}</a>
                <div v-if="parsedYandexQueryes[questid] != undefined && parsedYandexQueryes[questid] != null && parsedYandexQueryes[questid] != ''">
                  <div>Возможные ссылки:</div>
                  <div v-for="(parsed,parsedid) in parsedYandexQueryes[questid]" :key="'parseid-'+parsedid">
                    <a :href="parsed.url" target="_blank"><span style='font-size:10px'>{{parsed.url}}</span></a> Ключевые слова: <span v-for="passage in parsed.passages">{{passage}} </span> 
                  </div>
                </div>
            </div>
            
            <div
              class="form-group clearfix"
              v-for="(answer, answerid) in quest.answers"
              :key="answerid"
            >
              <input
                :name="'pole_' + level1id + level2id + questid"
                :id="'pole_' + level1id + level2id + questid + answerid"
                type="radio"
                :value="answer.id"
                v-model="quest.now"
              />
              <label
                class="form-control btn btn-info"
                :for="'pole_' + level1id + level2id + questid + answerid"
                >{{ answer.val }}</label
              >
            </div>
          </div>
        </template>
      </template>
      <button class='form-control btn btn-info' @click='newsave();'>Сохранить</button>
    </div>
    <div class="col-md-2">
      <img v-for="img in json" :src="img" :key="img" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import nprogress from "nprogress";

export default {
  created: function () {
    this.getfoto();
    this.startanketload();
    this.getanketinfo();
    this.newanketLoad();
    this.startParseYandex();
    this.getSite();
    this.checkQueryTimer();
  },
  methods: {
    getParseQuestion: function(){
      if(this.jsonquestion.level1 == undefined)
        return;
      const level1 = this.jsonquestion.level1[3];
      for (const level2Key in level1.level2) {
        if (level1.level2.hasOwnProperty(level2Key)) {
             const level2 = level1.level2[level2Key];
               if (level2.question) {
                 for (const questionKey in level2.question) {
                        if (level2.question.hasOwnProperty(questionKey)) {
                            const question = level2.question[questionKey];
                            if (question.id) {
                                //console.log(question.id);
                                axios({
                                  withCredentials: true,
                                  method: "GET",
                                  url: `http://eduqa.egechita.ru/back/checkQuery/${this.$route.params.id}/quest/${question.id}`
                                }).then(Response => {
                                    //this.parsedYandexQueryes[question.id] = Response.data;
                                    this.$set(this.parsedYandexQueryes, question.id, Response.data);
                                    console.log(Response);
                                    //this.parsedYandexQueryes[question.id] = Response.data;
                                }).catch({
                                  //
                                });
                            }
                        }
                    }
               }
        }
      }
    },
    getSite: function(){
      axios({
        withCredentials: true,
        method: "GET",
        url: `http://eduqa.egechita.ru/back/getSite/${this.$route.params.id}`
      }).then(Response => {
        this.site = Response.data.site;
      });
    },
    checkQueryTimer: function(){
      this.timer = setInterval(() => {
        axios({
          withCredentials: true,
          method: "GET",
          url: `http://eduqa.egechita.ru/back/checkQuery/${this.$route.params.id}`
        });
        this.getParseQuestion();
      }, 30000);
    },
    startParseYandex: function(){
      axios({
        withCredentials: true,
        method: "GET",
        url: `http://eduqa.egechita.ru/back/createQuerysInYandex/${this.$route.params.id}`
      });
    },
    startanketload: function(){
      nprogress.start();
      axios({
        withCredentials: true,
        url: "http://eduqa.egechita.ru/back/getstartquestionforeduexpertansket/" +
          this.$route.params.id,
        withCredentials: true,
        method: "get",
      }).then(Response => {
        this.jsonstartquestion = Response.data
         nprogress.done();
        });
    },

    newanketLoad: function(){
      nprogress.start();
      axios({
        withCredentials: true,
        url:
          "http://eduqa.egechita.ru/back/getquestionforeduexpertanket/" +
          this.$route.params.id,
        withCredentials: true,
        method: "get",
      }).then(Response => {
        this.jsonquestion = Response.data
         nprogress.done();
        });
    },
    getanketinfo: function () {
      nprogress.start();
      axios({
        url:
          "http://eduqa.egechita.ru/back/experteduanketinfoanswer/" +
          this.$route.params.id,
        withCredentials: true,
        method: "get",
      }).then((Response) => {
        nprogress.done();
        if (Response.data.isset == 1) {
          this.answers = Response.data.info;
        }
      });
    },
     newsave: function () {
      nprogress.start();
      axios({
        data: this.jsonquestion,
        url:
          "http://eduqa.egechita.ru/back/saveexperteduanket2/" +
          this.$route.params.id,
        withCredentials: true,
        method: "POST",
      }).then((Response) => {
        nprogress.done();
        //this.json = Response.data
      });
    },
    startnewsave: function () {
      nprogress.start();
      axios({
        data: this.jsonstartquestion,
        url:
          "http://eduqa.egechita.ru/back/startsaveexperteduanket2/" +
          this.$route.params.id,
        withCredentials: true,
        method: "POST",
      }).then((Response) => {
        nprogress.done();
        this.jsonquestion = {};
        this.newanketLoad();
        //this.json = Response.data
      });
    },
    sendData: function () {
      nprogress.start();
      axios({
        data: this.answers,
        url:
          "http://eduqa.egechita.ru/back/saveexperteduanket/" +
          this.$route.params.id,
        withCredentials: true,
        method: "POST",
      }).then((Response) => {
        nprogress.done();
        //this.json = Response.data
      });
    },
    getfoto: function () {
      nprogress.start();
      axios({
        url:
          "http://eduqa.egechita.ru/back/expertfoto/" + this.$route.params.id,
        withCredentials: true,
      }).then((Response) => {
        nprogress.done();
        this.json = Response.data;
      });
    },
  },
  data() {
    return {
      json: [],
      answers: [],
      jsonquestion: {},
      jsonstartquestion: {},
      timer: undefined,
      site: undefined,
      parsedYandexQueryes: [],
    };
  },
};
</script>
<style scoped>
input[type="radio"]:checked + label.btn {
  background-color: rgb(24, 218, 201);
}
input[type="radio"] {
  display: none;
}
</style>

